export const imageExtensions: Array<string> = [
  "jpg",
  "jpeg",
  "png",
  "gif",
  "bmp",
  "webp",
  "ico",
  "heic",
  "avif",
];

export const imageFormatExtensions: string = `image/x-png,image/jpeg,image/bmp`;

export const pdfExtensions: Array<string> = ["pdf"];

export const docExtensions: Array<string> = [
  "odt",
  "xls",
  "xlsx",
  "ods",
  "ppt",
  "pptx",
  "txt",
  "doc",
  "docx",
];

export const audioExtensions: Array<string> = [
  "mp3",
  "wav",
  "m4a",
  "opus",
  "webm",
  "aac",
  "voice",
  "note",
  "mxmf",
  "pcm",
  "aiff",
  "wma",
  "flac",
  "alac",
];

export const videoExtensions: Array<string> = [
  "mp4",
  "avi",
  "mov",
  "flv",
  "wmv",
];
